(() => {
  if (customElements.get('product-selector')) return;

  class ProductSelector extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      if (!this.form) return;

      this.submitButton = this.form.querySelector('[name="add"]');
      this.cartDrawer = document.querySelector('cart-drawer');

      this.variants = JSON.parse(
        this.querySelector('[type="application/json"]').textContent
      );

      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.addEventListener('change', this.onVariantChange.bind(this));

      this.updateOptions();
      this.updateVariant();

      if (!this.currentVariant) return;

      this.toggleDisableSize();
      this.updateMedia();
    }

    /* ================= SUBMIT ================= */
    onSubmitHandler(event) {
      event.preventDefault();
      if (!this.submitButton) return;

      this.submitButton.classList.add('disabled');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);

      if (this.cartDrawer) {
        formData.append(
          'sections',
          this.cartDrawer.getSectionsToRender().map(s => s.section)
        );
      }

      formData.append('sections_url', window.location.pathname);
      config.body = formData;

      fetch(routes.cart_add_url, config)
        .then(r => r.json())
        .then(response => {
          if (response.status) {
            this.handleErrorMessage(response.description);
            return;
          }

          this.cartDrawer?.renderContents(response);

          if (
            this.dataset.cartType === 'page' ||
            Shopify.template === 'cart'
          ) {
            window.location.reload();
          }
        })
        .catch(console.error)
        .finally(() => {
          this.submitButton.classList.remove('disabled');
        });
    }

    /* ================= VARIANT ================= */
    onVariantChange(event) {
      if (
        event.target.type === 'number' ||
        event.target.name?.includes('selling_plan')
      ) return;

      this.updateOptions();
      this.updateVariant();
      this.toggleAddButton(false);
      this.handleErrorMessage();

      if (!this.currentVariant) {
        this.toggleAddButton(true, window.variantStrings.unavailable);
        this.setUnavailable();
        return;
      }

      if (!this.currentVariant.available) {
        this.toggleAddButton(true, window.variantStrings.soldOut);
      }

      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.toggleDisableSize();
    }

    updateOptions() {
      this.options = Array.from(
        this.querySelectorAll('input[type="radio"]:checked, select'),
        el => el.value
      );
    }

    updateVariant() {
      this.currentVariant = this.variants.find(variant =>
        variant.options.every((opt, i) => opt === this.options[i])
      );
    }

    updateVariantInput() {
      const input = this.querySelector('[name="id"]');
      if (input && this.currentVariant) {
        input.value = this.currentVariant.id;
      }
    }

    updateURL() {
      if (!this.currentVariant || Shopify.template !== 'product') return;

      const params = new URLSearchParams(window.location.search);
      params.set('variant', this.currentVariant.id);

      window.history.replaceState(
        {},
        '',
        `${this.dataset.url}?${params.toString()}`
      );
    }

    /* ================= MEDIA ================= */
    updateMedia() {
      if (!this.currentVariant?.featured_media) return;

      const media = this.closest('[data-product]')
        ?.querySelector('product-media');

      media?.setActiveMedia(this.currentVariant.featured_media.id);
    }

    /* ================= UI ================= */
    toggleAddButton(disabled, text = window.variantStrings.addToCart) {
      if (!this.submitButton) return;

      if (disabled) {
        this.submitButton.setAttribute('disabled', 'disabled');
        this.submitButton.textContent = text;
      } else {
        this.submitButton.removeAttribute('disabled');
        this.submitButton.textContent = text;
      }
    }

    setUnavailable() {
      if (!this.submitButton) return;

      this.submitButton.textContent = window.variantStrings.unavailable;

      const price = this.querySelector(
        `#price-${this.dataset.sectionId} .price`
      );
      price?.classList.add('visibility-hidden');

      this.querySelectorAll('[data-size]').forEach(el =>
        el.removeAttribute('disabled')
      );

      this.querySelector('[data-size]:checked')
        ?.setAttribute('disabled', 'disabled');
    }

    toggleDisableSize() {
      const selected = this.querySelector('[data-size]:checked');
      if (!selected) return;

      this.querySelectorAll('[data-size]').forEach(el =>
        el.removeAttribute('disabled')
      );

      if (!this.currentVariant.available) {
        selected.setAttribute('disabled', 'disabled');
      }
    }

    /* ================= AJAX REFRESH ================= */
    renderProductInfo() {
      const params = new URLSearchParams(window.location.search);
      params.set('variant', this.currentVariant.id);
      params.append('section_id', this.dataset.sectionId);

      fetch(`${this.dataset.url}?${params.toString()}`)
        .then(r => r.text())
        .then(htmlText => {
          const html = new DOMParser().parseFromString(htmlText, 'text/html');

          const blocks = [
            'purchase-options',
            '[data-purchase-options-notification]',
            '[data-option-selected-value]',
            '[data-quantity-input]',
            '[data-pickup-availability]'
          ];

          blocks.forEach(selector => {
            const src = html.querySelector(selector);
            const dst = this.querySelector(selector);
            if (src && dst) dst.innerHTML = src.innerHTML;
          });

          // ==== PRICE UPDATE ====
          const priceSrc = html.querySelector(
            `#price-${this.dataset.sectionId}`
          );
          const priceDst = document.querySelector(
            `#price-${this.dataset.sectionId}`
          );

          if (priceSrc && priceDst) {
            priceDst.classList.remove('visibility-hidden');
            priceDst.innerHTML = priceSrc.innerHTML;

            // Forza la classe sale se c'è il prezzo barrato
            const compare = priceDst.querySelector('del');
            const sale = priceDst.querySelector('ins');
            if (compare && sale) {
              priceDst.classList.add('has-sale');
            } else {
              priceDst.classList.remove('has-sale');
            }
          }
        });
    }

    /* ================= ERRORS ================= */
    handleErrorMessage(message = '') {
      const wrapper = this.querySelector('[data-error-wrapper]');
      if (!wrapper) return;

      wrapper.classList.toggle('hidden', !message);
      wrapper.textContent = message;
    }
  }

  customElements.define('product-selector', ProductSelector);
})();
